export default __webpack_public_path__ + "static/media/google-play-store-badge.8dd75ca7.png";